import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
  TimeEntry,
  EntrySaveResult,
  BulkSaveResult,
  ApiResponse,
} from '@com.maessa.payroll.frontend/models';

export type TimeEntryPayload = Omit<TimeEntry, 'employee' | 'validation_errors' | 'created_at' | 'updated_at'>;

@Injectable({ providedIn: 'root' })
export class TimeEntryApiService extends BaseApiService {
  getEntries(workSheetId: number): Observable<ApiResponse<TimeEntry[]>> {
    return this.get<ApiResponse<TimeEntry[]>>(
      `${this.baseUrl}/worksheets/${workSheetId}/entries`
    );
  }

  saveEntry(workSheetId: number, payload: TimeEntryPayload): Observable<EntrySaveResult> {
    if (payload.id) {
      return this.put<EntrySaveResult>(
        `${this.baseUrl}/worksheets/${workSheetId}/entries/${payload.id}`,
        payload
      );
    }
    return this.post<EntrySaveResult>(
      `${this.baseUrl}/worksheets/${workSheetId}/entries`,
      payload
    );
  }

  bulkSave(workSheetId: number, entries: TimeEntryPayload[]): Observable<BulkSaveResult> {
    return this.post<BulkSaveResult>(
      `${this.baseUrl}/worksheets/${workSheetId}/entries/bulk`,
      { entries }
    );
  }

  deleteEntry(workSheetId: number, entryId: number): Observable<void> {
    return this.delete<void>(
      `${this.baseUrl}/worksheets/${workSheetId}/entries/${entryId}`
    );
  }
}
